import React from 'react';

interface NewCommitSlideOutContextType {
  draftCommit: Commitment | CreateCommitmentArgs;
  setDraftCommit: React.Dispatch<
    React.SetStateAction<Commitment | CreateCommitmentArgs>
  >;
  hasManualLineHaulCharge: boolean;
  setHasManualLineHaulCharge: React.Dispatch<React.SetStateAction<boolean>>;
  showWarnings: boolean;
}

const NewCommitSlideOutContext = React.createContext(
  {} as NewCommitSlideOutContextType,
);

export default NewCommitSlideOutContext;
